export default function Services() {
  const services = [
    {
      title: 'MUSIC STUDIO',
      icon: 'ri-music-2-line',
      color: '#ff6b35',
      gradient: 'from-purple-900/50 to-black',
      items: [
        'Recording & Mixing',
        'Mastering & Beats',
        'Podcasts & Voiceovers',
        'Music Production',
        'Vocal Coaching'
      ],
      image: 'https://public.readdy.ai/ai/img_res/d6d88602fbdebfa3a43dd49dd28dfc55.jpg'
    },
    {
      title: 'GRAPHIC DESIGN',
      icon: 'ri-pencil-ruler-2-line',
      color: '#00d9ff',
      gradient: 'from-cyan-900/50 to-black',
      items: [
        'Logo Design',
        'Brand Identity',
        'Posters & Flyers',
        'Social Media Posts',
        'Apparel Artwork',
        'Business Cards'
      ],
      image: 'https://readdy.ai/api/search-image?query=Creative%20graphic%20design%20workspace%20with%20vibrant%20colorful%20design%20samples%20and%20mockups%2C%20modern%20computer%20screen%20showing%20design%20work%2C%20professional%20designer%20desk%20setup%2C%20brand%20identity%20materials%2C%20color%20swatches%2C%20artistic%20creative%20environment%20with%20cyan%20and%20orange%20accent%20lighting&width=600&height=800&seq=service-design-001&orientation=portrait'
    },
    {
      title: 'POST PRODUCTION',
      icon: 'ri-equalizer-line',
      color: '#d4af37',
      gradient: 'from-gray-800 to-gray-900',
      items: [
        'Audio Editing',
        'Sound Design',
        'Final Mix & Master',
        'Audio Cleanup',
        'Sync Preparation',
        'Restoration'
      ],
      image: 'https://readdy.ai/api/search-image?query=Professional%20audio%20mixing%20console%20with%20faders%20and%20knobs%20in%20detail%2C%20post%20production%20studio%20equipment%2C%20digital%20audio%20workstation%20setup%2C%20sound%20engineering%20workspace%2C%20precise%20audio%20editing%20environment%2C%20professional%20grade%20mixing%20board%20with%20warm%20lighting&width=600&height=800&seq=service-post-001&orientation=portrait'
    }
  ];

  return (
    <section id="services" className="py-24 px-6 bg-[#1a1a1a]">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <header className="mb-16">
          <div className="text-[#00d9ff] text-sm font-semibold tracking-widest mb-4">(WHAT WE DO)</div>
          <h2 className="text-5xl md:text-6xl font-bold">
            <span className="text-white">COMPLETE CREATIVE</span><br />
            <span className="text-gray-500 italic font-light">SOLUTIONS</span>
          </h2>
        </header>

        {/* Services Grid */}
        <div className="grid md:grid-cols-3 gap-10">
          {services.map((service, index) => (
            <article 
              key={index}
              className="group relative rounded-[32px] overflow-hidden hover:transform hover:scale-105 transition-all duration-500 cursor-pointer"
            >
              {/* Background Image with Overlay */}
              <div className="absolute inset-0">
                <img 
                  src={service.image}
                  alt={`${service.title} Services at Master Jae Production Parys`}
                  title={`Professional ${service.title} - Master Jae Production`}
                  className="w-full h-full object-cover object-top"
                />
                <div className={`absolute inset-0 bg-gradient-to-b ${service.gradient} group-hover:opacity-90 transition-opacity duration-300`}></div>
              </div>

              {/* Content */}
              <div className="relative p-8 min-h-[500px] flex flex-col justify-between">
                {/* Icon Badge */}
                <div 
                  className="w-16 h-16 rounded-full flex items-center justify-center mb-6"
                  style={{ backgroundColor: service.color }}
                >
                  <i className={`${service.icon} text-white text-2xl`}></i>
                </div>

                {/* Service Details */}
                <div>
                  <h3 className="text-white text-3xl font-bold mb-6">{service.title}</h3>
                  
                  <ul className="space-y-3 mb-8">
                    {service.items.map((item, idx) => (
                      <li key={idx} className="text-gray-300 flex items-center space-x-2">
                        <i className="ri-check-line" style={{ color: service.color }}></i>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>

                  <div className="flex items-center space-x-2 text-[#00d9ff] text-sm font-semibold group-hover:translate-x-2 transition-transform duration-300">
                    <span>EXPLORE SERVICES</span>
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
